/**
 * Примеры вопросов для первого входа — из данных самого человека.
 *
 * Общие примеры («смогу купить ноутбук?») ничего не говорят тому, у кого нет
 * ноутбука в планах. Вопрос про его карту, его цель и его зарплату сразу
 * показывает, что SKOKA видит его деньги. Собираются на телефоне, без
 * модели: бесплатно и сразу.
 */
import type { AdvisorContext } from '@skoka/core';
import { dayMonth } from '../text.js';

const GENERIC = [
  'Сколько я могу тратить в день?',
  'Хватит ли денег на платежи в этом месяце?',
  'На что у меня уходит больше всего?',
];

export function examplesFor(ctx: AdvisorContext, max = 3): string[] {
  const today = ctx.today;
  const day = (d: string) => dayMonth(d, today);
  const out: string[] = [];

  const card = ctx.cards
    .filter((c) => c.toPay > 0 && c.payBy >= today)
    .sort((a, b) => a.payBy.localeCompare(b.payBy))[0];
  if (card) out.push(`Хватит ли денег на платёж по карте «${card.name}» ${day(card.payBy)}?`);

  const goal = ctx.refs.goals
    .filter((g) => g.status === 'active' && g.target > g.saved)
    .sort((a, b) => (a.by ?? '9999').localeCompare(b.by ?? '9999'))[0];
  if (goal) {
    out.push(goal.by && goal.by >= today
      ? `Успею накопить на цель «${goal.name}» к ${day(goal.by)}?`
      : `Когда накоплю на цель «${goal.name}»?`);
  }

  const variable = ctx.incomes.find((i) => i.variable && i.next);
  if (variable) out.push(`Что будет, если доход «${variable.name}» придёт позже?`);

  const next = ctx.incomes
    .filter((i) => i.next && i.next >= today)
    .sort((a, b) => a.next!.localeCompare(b.next!))[0];
  if (next && out.length < max) out.push(`Сколько можно тратить в день до ${day(next.next!)}?`);

  for (const g of GENERIC) {
    if (out.length >= max) break;
    out.push(g);
  }
  return out.slice(0, max);
}
